// navbar/navbar.module.ts
import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { ActiveLinkDirective } from 'src/app/shared/active-link.directive';

@NgModule({
  declarations: [NavbarComponent, ActiveLinkDirective],
  imports: [CommonModule, SharedModule],
  exports: [NavbarComponent],
})
export class NavbarModule {}
